class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    // Cancel any pending close on this menu
    clearTimeout(this._closeTimer);

    // Close every other open header-menu first
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) {
        clearTimeout(menu._closeTimer);
        menu.close();
      }
    });

    // Open this menu
    this.mainDetailsToggle.open = true;
  }

  onSummaryClick(event) {
    // For promo-only items (no child links), navigate to the link URL on click
    const summary = event.target.closest('summary[data-nav-url]');
    if (summary) {
      event.preventDefault();
      window.location.href = summary.dataset.navUrl;
    }
  }

  onMouseLeave() {
    // Small delay so moving from nav link into the dropdown doesn't flicker
    this._closeTimer = setTimeout(() => this.close(), 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
